import axios from "axios";

export interface IcdoData {
  icdoCode: string;
  level: string;
  term: string;
  reference: string;
  obs: string;
  seeAlso: string;
  seeNote: string;
  includes: string;
  excludes: string;
  otherText: string;
  seer: string;
  npcr: string;
  coc: string;
  cccr: string;
  remarks: string;
};

export interface Version {
  version: string;
}

type DataApi = {
  getData(): Promise<IcdoData[]>;
  getData2(version: string): Promise<IcdoData[]>;
  getVersions(): Promise<Version[]>;
};

const baseUrl = "api/v0/data"

const dataApi: DataApi = {
  async getData() {
    const { data: data } = await axios.get<IcdoData[]>(baseUrl);
    return data;
  },
  async getData2(version) {
    const model: Version = {
      version: version
    };
    const { data: data } = await axios.post<IcdoData[]>(baseUrl, model);
    return data;
  },
  async getVersions() {
    const { data: data } = await axios.get<Version[]>(`${baseUrl}/versions`);
    return data;
  }
};

export default dataApi;